import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import Seo from "@/components/Seo";
import { adminLogin } from "@/lib/auth";

const inputCls =
  "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-zinc-500 focus:outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-colors";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Admin Login | CYAN Wireless" description="CYAN Wireless admin." path="/admin/login" />
      <section className="min-h-screen grid place-items-center bg-ink-950 px-5 pt-24 pb-16">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-cyan-500/15 border border-cyan-500/30 text-cyan-400 mb-5"><Lock size={22} /></div>
            <h1 className="font-display font-black text-4xl tracking-tighter text-white">Admin Access</h1>
            <p className="text-zinc-400 mt-2 text-sm">Sign in to view form submissions.</p>
          </div>
          <form onSubmit={onSubmit} className="bg-ink-900 border border-white/10 rounded-2xl p-8 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="overline block mb-2">Email</label>
              <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@cyanwireless.net" data-testid="admin-email" />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password" />
            </div>
            {error && <p className="text-sm text-red-400" data-testid="admin-error">{error}</p>}
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-cyan-500 text-ink-950 font-display font-bold uppercase tracking-widest px-8 py-4 rounded-xl btn-glow hover:bg-cyan-400 disabled:opacity-60" data-testid="admin-login-submit">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />} Sign In
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
